module.exports = __webpack_public_path__ + "img/c9.e8ae06e7.png";